<script>
    import { api_host, price_setting_store, user_store } from "../../stores.js";
    import { init_data } from '../../init.js';
    import Header from "../header.svelte";
    import IFTAInput from "../../utils/iftainput.svelte";
    import HeaderFilter from '../../utils/ItemFilter.svelte';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { handle_not_subscribed } from '../../utils/format.js';


    let is_busy = false;
    let myself = {};

    user_store.subscribe(value => {
        myself = value;
    });

    let table_header_config = [
        {'t': 'Client Margin', 'fm': 'lm', 'a': true},
        {'t': 'Contractor Margin', 'fm': 'om', 'a': true},
        {'t': 'Yard Factor - 1 Story', 'fm': 'os', 'a': false},
        {'t': 'Yard Factor > 1 Story', 'fm': 'ts', 'a': false},
        {'t': 'Lawn - Front AND Back', 'fm': 'fa', 'a': false},
        {'t': 'Lawn - Front OR Back', 'fm': 'fo', 'a': false},
        {'t': 'Lawn - None', 'fm': 'dt', 'ln': false},
        {'t': 'Service - Once', 'fm': 'so', 'a': false},
        {'t': 'Service - Weekly', 'fm': 'sw', 'a': false},
        {'t': 'Service - Bi-Weekly', 'fm': 'sb', 'a': false},
        {'t': 'Service - Monthly', 'fm': 'sm', 'a': false},
        {'t': 'Last Serviced < 2 Weeks', 'fm': 'lt', 'a': false},
        {'t': 'Last Serviced 2 - 4 Weeks', 'fm': 'lf', 'a': false},
        {'t': 'Last Serviced 1 - 2 Months', 'fm': 'lom', 'a': false},
        {'t': 'Last Serviced >= 3 Months', 'fm': 'stm', 'a': true},
        {'t': 'Discount - Monthly Service', 'fm': 'dms', 'a': true},
        {'t': 'Referral Duration (days)', 'fm': 'stm', 'a': true},
        {'t': 'Referral Discount', 'fm': 'stm', 'a': true},
    ];

    let fields = [
        {
            "index": 0,
            "group": "referrals",
            "type": "text",
            "label": "Duration (in days)",
            "value": "",
            "placeholder": "eg. 7",
            "name": "price_setting[referral_duration]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[0].value) >= 0) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    fields[0]['error_text'] = 'Invalid Referral Duration days';
                    return false;
                }
            }
        }, {
            "index": 1,
            "group": "referrals",
            "type": "text",
            "label": "Discount (in %)",
            "value": "",
            "placeholder": "eg. 10.0",
            "name": "price_setting[referral_discount]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[1].value) >= 0) {
                    fields[1]['show_error'] = false;
                    return true;
                } else {
                    fields[1]['show_error'] = true;
                    fields[1]['error_text'] = 'Invalid Referral Discount';
                    return false;
                }
            }
        }, {
            "index": 2,
            "group": "margins",
            "type": "text",
            "label": "Client Margin",
            "value": "",
            "placeholder": "eg. 1.35",
            "name": "price_setting[client_margin]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[2].value) >= 0) {
                    fields[2]['show_error'] = false;
                    return true;
                } else {
                    fields[2]['show_error'] = true;
                    fields[2]['error_text'] = 'Invalid Client Margin';
                    return false;
                }
            }
        }, {
            "index": 3,
            "group": "margins",
            "type": "text",
            "label": "Contractor Margin",
            "value": "",
            "placeholder": "eg. 0.8",
            "name": "price_setting[contractor_margin]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[3].value) >= 0) {
                    fields[3]['show_error'] = false;
                    return true;
                } else {
                    fields[3]['show_error'] = true;
                    fields[3]['error_text'] = 'Invalid Contractor Margin';
                    return false;
                }
            }
        }, {
            "index": 4,
            "group": "lawnfactors",
            "type": "text",
            "label": "Lawn for 1 Story",
            "value": "",
            "placeholder": "eg. 0.38",
            "name": "price_setting[lawnfor_small_story]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[4].value) >= 0) {
                    fields[4]['show_error'] = false;
                    return true;
                } else {
                    fields[4]['show_error'] = true;
                    fields[4]['error_text'] = 'Invalid value';
                    return false;
                }
            }
        }, {
            "index": 5,
            "group": "lawnfactors",
            "type": "text",
            "label": "Lawn for >1 Story",
            "value": "",
            "placeholder": "eg. 0.45",
            "name": "price_setting[lawnfor_big_story]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[5].value) >= 0) {
                    fields[5]['show_error'] = false;
                    return true;
                } else {
                    fields[5]['show_error'] = true;
                    fields[5]['error_text'] = 'Invalid value';
                    return false;
                }
            }
        }, {
            "index": 6,
            "group": "lawnfactors",
            "type": "text",
            "label": "Front or Back",
            "value": "",
            "placeholder": "eg. 1.0",
            "name": "price_setting[front_or_back]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[6].value) >= 0) {
                    fields[6]['show_error'] = false;
                    return true;
                } else {
                    fields[6]['show_error'] = true;
                    fields[6]['error_text'] = 'Invalid Front or Back';
                    return false;
                }
            }
        }, {
            "index": 7,
            "group": "lawnfactors",
            "type": "text",
            "label": "Front and Back",
            "value": "",
            "placeholder": "eg. 1.11",
            "name": "price_setting[front_and_back]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[7].value) >= 0) {
                    fields[7]['show_error'] = false;
                    return true;
                } else {
                    fields[7]['show_error'] = true;
                    fields[7]['error_text'] = 'Invalid Front and Back';
                    return false;
                }
            }
        }, {
            "index": 8,
            "group": "lawnfactors",
            "type": "text",
            "label": "No Lawn",
            "value": "",
            "placeholder": "eg. 0.95",
            "name": "price_setting[no_lawn]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[8].value) >= 0) {
                    fields[8]['show_error'] = false;
                    return true;
                } else {
                    fields[8]['show_error'] = true;
                    fields[8]['error_text'] = 'Invalid No Lawn';
                    return false;
                }
            }
        }, {
            "index": 9,
            "group": "servicefactors",
            "type": "text",
            "label": "One Time",
            "value": "",
            "placeholder": "eg. 1.65",
            "name": "price_setting[one_time]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[9].value) >= 0) {
                    fields[9]['show_error'] = false;
                    return true;
                } else {
                    fields[9]['show_error'] = true;
                    fields[9]['error_text'] = 'Invalid One Time';
                    return false;
                }
            }
        }, {
            "index": 10,
            "group": "servicefactors",
            "type": "text",
            "label": "Weekly",
            "value": "",
            "placeholder": "eg. 0.74",
            "name": "price_setting[weekly]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[10].value) >= 0) {
                    fields[10]['show_error'] = false;
                    return true;
                } else {
                    fields[10]['show_error'] = true;
                    fields[10]['error_text'] = 'Invalid Weekly value';
                    return false;
                }
            }
        }, {
            "index": 11,
            "group": "servicefactors",
            "type": "text",
            "label": "Bi-Weekly",
            "value": "",
            "placeholder": "eg. 0.89",
            "name": "price_setting[bi_weekly]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[11].value) >= 0) {
                    fields[11]['show_error'] = false;
                    return true;
                } else {
                    fields[11]['show_error'] = true;
                    fields[11]['error_text'] = 'Invalid Bi-Weekly value';
                    return false;
                }
            }
        }, {
            "index": 12,
            "group": "servicefactors",
            "type": "text",
            "label": "Monthly",
            "value": "",
            "placeholder": "eg. 1.57",
            "name": "price_setting[monthly]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[12].value) >= 0) {
                    fields[12]['show_error'] = false;
                    return true;
                } else {
                    fields[12]['show_error'] = true;
                    fields[12]['error_text'] = 'Invalid Monthly value';
                    return false;
                }
            }
        }, {
            "index": 13,
            "group": "lastservicefactors",
            "type": "text",
            "label": "Last Serviced < 2 weeks",
            "value": "",
            "placeholder": "eg. 0.89",
            "name": "price_setting[last_serviced_2]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[13].value) >= 0) {
                    fields[13]['show_error'] = false;
                    return true;
                } else {
                    fields[13]['show_error'] = true;
                    fields[13]['error_text'] = 'Invalid value';
                    return false;
                }
            }
        }, {
            "index": 14,
            "group": "lastservicefactors",
            "type": "text",
            "label": "Last Serviced 2 - 4 weeks",
            "value": "",
            "placeholder": "eg. 1.56",
            "name": "price_setting[last_serviced_4]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[14].value) >= 0) {
                    fields[14]['show_error'] = false;
                    return true;
                } else {
                    fields[14]['show_error'] = true;
                    fields[14]['error_text'] = 'Invalid value';
                    return false;
                }
            }
        }, {
            "index": 15,
            "group": "lastservicefactors",
            "type": "text",
            "label": "Last Serviced 1 - 2 months",
            "value": "",
            "placeholder": "eg. 2.5",
            "name": "price_setting[last_serviced_8]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[15].value) >= 0) {
                    fields[15]['show_error'] = false;
                    return true;
                } else {
                    fields[15]['show_error'] = true;
                    fields[15]['error_text'] = 'Invalid value';
                    return false;
                }
            }
        }, {
            "index": 16,
            "group": "lastservicefactors",
            "type": "text",
            "label": "Last Serviced >= 3 months",
            "value": "",
            "placeholder": "eg. 3.8",
            "name": "price_setting[last_serviced_12]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[16].value) >= 0) {
                    fields[16]['show_error'] = false;
                    return true;
                } else {
                    fields[16]['show_error'] = true;
                    fields[16]['error_text'] = 'Invalid value';
                    return false;
                }
            }
        }, {
            "index": 17,
            "group": "discounts",
            "type": "text",
            "label": "Discount Monthly Service",
            "value": "",
            "placeholder": "eg. 0.3",
            "name": "price_setting[discount_monthly]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[17].value) >= 0) {
                    fields[17]['show_error'] = false;
                    return true;
                } else {
                    fields[17]['show_error'] = true;
                    fields[17]['error_text'] = 'Invalid value';
                    return false;
                }
            }
        }, {
            "index": 18,
            "group": "service_charge",
            "type": "text",
            "label": "Minimum Service Charge",
            "value": "",
            "placeholder": "eg. 1",
            "name": "price_setting[min_charge]",
            "disabled": myself.role === 'manager',
            "validation_function": () => {
                if (parseFloat(fields[18].value) >= 0) {
                    fields[18]['show_error'] = false;
                    return true;
                } else {
                    fields[18]['show_error'] = true;
                    fields[18]['error_text'] = 'Invalid value';
                    return false;
                }
            }
        },
    ];

    price_setting_store.subscribe(price_setting => {
        fields[0].value = price_setting.referral_duration;
        fields[1].value = price_setting.referral_discount;
        fields[2].value = price_setting.client_margin;
        fields[3].value = price_setting.contractor_margin;
        fields[4].value = price_setting.lawnfor_small_story;
        fields[5].value = price_setting.lawnfor_big_story;
        fields[6].value = price_setting.front_or_back;
        fields[7].value = price_setting.front_and_back;
        fields[8].value = price_setting.no_lawn;
        fields[9].value = price_setting.one_time;
        fields[10].value = price_setting.weekly;
        fields[11].value = price_setting.bi_weekly;
        fields[12].value = price_setting.monthly;
        fields[13].value = price_setting.last_serviced_2;
        fields[14].value = price_setting.last_serviced_4;
        fields[15].value = price_setting.last_serviced_8;
        fields[16].value = price_setting.last_serviced_12;
        fields[17].value = price_setting.discount_monthly;
        fields[18].value = price_setting.min_charge;
    });

    const validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (!field.validation_function()) { is_valid = false; }
        });
        return is_valid;
    }
    const save_settings = async () => {
        if (myself['is_subscribed'] !== undefined && !myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }
        if (validateForm()) {
            is_busy = true;
            const payload = {
                client_margin: fields[2].value,
                contractor_margin: fields[3].value,
                lawnfor_small_story: fields[4].value,
                lawnfor_big_story: fields[5].value,
                front_or_back: fields[6].value,
                front_and_back: fields[7].value,
                no_lawn: fields[8].value,
                one_time: fields[9].value,
                weekly: fields[10].value,
                bi_weekly: fields[11].value,
                monthly: fields[12].value,
                last_serviced_2: fields[13].value,
                last_serviced_4: fields[14].value,
                last_serviced_8: fields[15].value,
                last_serviced_12: fields[16].value,
                discount_monthly: fields[17].value,
                min_charge: fields[18].value,
                referral_duration: fields[0].value,
                referral_discount: fields[1].value,
            };

            const { auth_type, auth_token, domain_code } = getToken();
            const turl = api_host + "/api/landscaper/update/price_setting";
            const headers = { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' };
            const res = await doFetch(turl, 'POST', payload, headers);
            if (res.status) {
                toast_message(true, res.msg, 2000);
                init_data('prices');
            } else {
                toast_message(false, res.msg, 2000);
            }
            is_busy = false;
        }
    }
</script>

<Header title="Pricing Settings" />

<div class="contentholder">
    <div class='pagenote'>
        <p>View or update your lawn care service instant price quote below:</p>
    </div>

    <div class="settingsqlbutton">
        <!-- <HeaderFilter title="Configure Settings Quicklist" bind:filter_items={table_header_config} /> -->
    </div>

    <div class="section pricingsettings">
        <div class="sectionsubtitle">Margins</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff rowwrap pricingsettings">
                {#each fields.filter((e)=>e.group === "margins") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>    
        </div>

        <div class="sectionsubtitle">Lawn Factors</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff rowwrap pricingsettings">
                {#each fields.filter((e)=>e.group === "lawnfactors") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>    
        </div>

        <div class="sectionsubtitle">Service Frequency Multipliers</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff rowwrap pricingsettings">
                {#each fields.filter((e)=>e.group === "servicefactors") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>    
        </div>

        <div class="sectionsubtitle">Lawn Growth Multipliers</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff rowwrap pricingsettings">
                {#each fields.filter((e)=>e.group === "lastservicefactors") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>    
        </div>

        <!-- <div class="sectionsubtitle">Service Charge</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff rowwrap pricingsettings">
                {#each fields.filter((e)=>e.group === "service_charge") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>    
        </div> -->

        <!-- <div class="sectionsubtitle">Discount Factors</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff rowwrap pricingsettings">
                {#each fields.filter((e)=>e.group === "discounts") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>    
        </div> -->
    </div>

    <div class="section referralsettings">
        <div class="sectiontitle"><i class="fas fa-hand-holding-usd"></i> Referral Settings</div>
        <div class="sectioninfo referralsettings">
            <div class="row elink">
                <!-- <span>Example referral link:</span> https://demo.houseofyards.com/booking?gid=customer_email&refid=AXRIDRID  -->
            </div>
            <div class="row referralsettings">
                <div class="ff rowwrap">
                    {#each fields.filter((e) => e.group === "referrals") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                        readonly={nf.readonly}
                        disabled={nf.disabled}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:value={nf.value}
                        bind:change_function={nf.change_function}
                        bind:validation_function={nf.validation_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                    {/each}
                </div>
            </div>
        </div>
    </div>

    {#if myself.role !== 'manager'}
        <div class="section updatebutton">
            <button class="save" on:click={save_settings} disabled={is_busy}>Save Settings</button>
        </div>
    {/if}
</div>
        

<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .row{
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "pn pn pn pn pn pn pn pn pn pn pn pn"
                             "sq sq sq sq sq sq sq sq sq sq sq sq"
                             "ps ps ps ps ps ps ps ps ps ps ps ps"
                             "rs rs rs rs rs rs rs rs rs rs rs rs"
                             "ub ub ub ub ub ub ub ub ub ub ub ub";
        gap: 20px;
    }
    .settingsqlbutton {
        grid-area: sq;
        width: 100%;
        display:flex;
        flex-direction: row;
        justify-content: center;
    }
    .pagenote {
        grid-area: pn;
    }
    .pagenote p {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 0px;
    }
    .pricingsettings {
        grid-area: ps;
    }
    .referralsettings {
        grid-area: rs;
    }
    .updatebutton {
        grid-area: ub;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
    .updatebutton .save {
        width: 200px;
        background-color: #357a38;
        color: white;
    }
    .elink {
        display: flex;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        color: #666;
        font-style: italic;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    :global(.settingsqlbutton .filterbuttonholder) {
        width: 600px !important;
    }
    .section {
        border: 1px solid #1769aa;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 0px;
            width: 100%;
        }
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "pn"
                                 "sq"
                                 "ps"
                                 "rs"
                                 "ub";
            gap: 20px;
        }
        .pagenote {
            grid-area: pn;
        }
        .settingsqlbutton {
            grid-area: sq;
            width: 100%;
            display:flex;
            flex-direction: row;
            justify-content: center;
        }
        .pricingsettings {
            grid-area: ps;
        }
        .referralsettings {
            grid-area: rs;
        }
        .updatebutton {
            grid-area: ub;
            display: flex;
            flex-direction: column;
            padding: 0px;
        }
        .updatebutton .save {
            width: 100%;
            background-color: #357a38;
            color: white;
        }
        .elink {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            color: #666;
            font-style: italic;
        }
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        :global(.settingsqlbutton .filterbuttonholder) {
            width: 100% !important;
        }
    }
</style>